import { EVOLUTION_THEME } from './evolutionTheme';

/** Fundo leve para diferenciar acréscimos do corpo principal da evolução */
export const evolutionAdditionSurfaceBg = '#eff6ff';
export const evolutionAdditionSurfaceBorder = '#dbeafe';

export const evolutionAdditionItemSx = {
  border: `1px solid ${evolutionAdditionSurfaceBorder}`,
  borderRadius: 1.5,
  p: 1.5,
  bgcolor: evolutionAdditionSurfaceBg,
};

export const evolutionAdditionPanelSx = {
  mt: 1.25,
  mb: 0.5,
  borderRadius: 1.5,
  border: `1px solid ${evolutionAdditionSurfaceBorder}`,
  bgcolor: evolutionAdditionSurfaceBg,
  px: 1.5,
  py: 1.25,
};

export const evolutionAdditionHeadingSx = {
  fontWeight: 700,
  fontSize: '0.7rem',
  letterSpacing: '0.04em',
  color: EVOLUTION_THEME.navy,
  display: 'block',
  mb: 0.75,
};
